import * as React from 'react';
import WebGLDirector from '../../webGL/WebGLDirector';
import GLComponent from './GLComponent';
import WebGLText from '../../webGL/WebGLText';
import WebGLArrow from '../../webGL/shapes/composites/WebGLArrow';
import WebGLLineStrip from '../../webGL/shapes/primitives/WebGLLineStrip';
import WebGLLineLoop from '../../webGL/shapes/primitives/WebGLLineLoop';

export default class CurvesComponent extends GLComponent {

	componentDidMount () {
		const director = new WebGLDirector(this.canvas, this.props.width, this.props.height, this.textOverlay);

		const func = (x: number) => Math.pow(x, 2);

		director.addShape(WebGLLineStrip.fromFunction(func, -1, 1, 64, 2, 1).translate(-.45, 0, 0));
		director.addShape(WebGLArrow.fromNumbers(-.95 + 2 / 128, func(-1 + 2 / 64), -.95, func(-1)));
		director.addShape(WebGLArrow.fromNumbers(-.95 + 126 / 128, func(-1 + 126 / 64), -.95 + 1, func(1)));
		director.addText(new WebGLText('A curve', -.53, -.1));

		director.addShape(WebGLLineLoop.circle(0.7, 0.7, 0.25, 64));
		director.addText(new WebGLText('A closed curve', .55, .35));

		director.addShape(WebGLLineLoop.fromNumbers([0, .2, .5, .2, .1, .4]));
		director.addText(new WebGLText('Not a closed curve', .05, .1));

		director.addShape(WebGLLineStrip.fromFunction(func, -.5, .5, 32, 2, 1).rotateZ(Math.PI / 3).translate(.2, -.5, 0));
		director.addText(new WebGLText('An arc', .3, -.7));

		director.drawScene();
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/lesson/WebGL/CurvesComponent.tsx